import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            <i className="ri-fire-line text-primary-500 mr-2"></i>
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的热门漫画，每日更新</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}